export default __webpack_public_path__ + "static/media/banner-top-left.26bf1456.svg";